import { render, staticRenderFns } from "./ThemeToggler.vue?vue&type=template&id=35b6d8f7&"
import script from "./ThemeToggler.vue?vue&type=script&lang=js&"
export * from "./ThemeToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports